// 予約の種類を表す定数
export const APPOINTMENT_TYPES = {
  FIRST_VISIT: {
    id: 1,
    name: "初診",
  },
  FOLLOW_UP: {
    id: 2,
    name: "再診",
  },
};

// 性別の種類を表す定数
export const GENDER_TYPES = {
  MALE: {
    id: 1,
    name: "男性",
  },
  FEMALE: {
    id: 2,
    name: "女性",
  },
};

// アカウントの有無選択
export const ACCOUNT_VERIFY_TYPES = {
  // アカウントを持っている
  NO_ACCOUNT: 1,
  // アカウントを持っていない
  HAS_ACCOUNT: 2,
};

// 予約可不可の種類を表す定数
export const RESERVATION_TYPES = {
  // 予約可
  AVAILABLE: {
    id: "AVAILABLE",
    mark: "○",
    className: "available",
  },
  // あと少し
  FEW_LEFT: {
    id: "FEW_LEFT",
    mark: "△",
    className: "few-left",
  },
  // 予約不可
  FULL: {
    id: "FULL",
    mark: "✕",
    className: "full",
  },
  // 休診日
  CLOSED: {
    id: "CLOSED",
    mark: "-",
    className: "closed",
  },
};

// 質問の種類の文字を表す定数
export const QUESTION_TYPES = {
  // チェックボックス
  MULTIPLE: 2,
  // ラジオボタン
  SINGLE: 1,
  // テキスト(短文回答)
  TEXT_FIELD: 3,
  // テキスト(長文回答)
  TEXT_AREA: 4,
};

// 日付選択画面のモードを表す定数
export const DATETIME_SELECT_MODE = {
  // 日時の変更画面
  CHANGE: "change",
};

// 曜日の種類を表す定数
export const WEEKDAY_TYPES = {
  SUNDAY: {
    id: 0,
    name: "日曜日",
    abbr: "日",
    className: "sunday",
  },
  MONDAY: {
    id: 1,
    name: "月曜日",
    abbr: "月",
    className: "monday",
  },
  TUESDAY: {
    id: 2,
    name: "火曜日",
    abbr: "火",
    className: "tuesday",
  },
  WEDNESDAY: {
    id: 3,
    name: "水曜日",
    abbr: "水",
    className: "wednesday",
  },
  THURSDAY: {
    id: 4,
    name: "木曜日",
    abbr: "木",
    className: "thursday",
  },
  FRIDAY: {
    id: 5,
    name: "金曜日",
    abbr: "金",
    className: "friday",
  },
  SATURDAY: {
    id: 6,
    name: "土曜日",
    abbr: "土",
    className: "saturday",
  },
};

// メール送信の種類を表す定数
export const Mail_TYPES = {
  FIRSTSEND: {
    id: 0,
    string: "0",
    name: "初回送信",
  },
  RESEND: {
    id: 1,
    string: "1",
    name: "再送信",
  },
};

// エラーコードを表す定数
export const ERROR_CODES = {
  ExpiredADB2CToken: "1008",
};
